export const classLister = (styleObject: { [x: string]: any; }) => (...classList: any[]): any =>
    classList.reduce((list, myClass) => {
        let output = list;
        if (styleObject[myClass]) {
            if (list) output += ' ';
            output += styleObject[myClass];
        }
        return output;
    }, '');

export const conditionalClassLister = (styleObject: { [x: string]: any; }) => (toJoin: { [x: string]: any; }): any => {
    const classList = Object.getOwnPropertyNames(toJoin).map((x) => {
        const value = toJoin[x];
        if (!value) {
            return '';
        }
        return x;
    });

    return classLister(styleObject)(...classList);
};
